/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react'

const SentrixContext = createContext({
  nonce: '',
  policies: {},
  reportOnly: false,
})

export function SentrixProvider({ children, nonce = '', policies = {}, reportOnly = false }) {
  return <SentrixContext.Provider value={{ nonce, policies, reportOnly }}>{children}</SentrixContext.Provider>
}

export const useSentrix = () => useContext(SentrixContext)

export default SentrixProvider
